export { default } from './CustomAnimatedIcon'
